import { ThemeContext } from "@emotion/react";
import React, { useContext, useRef, useState } from "react";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import Paper from "@mui/material/Paper";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Collapse,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Table,
  TableContainer,
  TextField,
  Typography,
} from "@mui/material";
import { ProcesarMovimiento } from "../../../hooks/procesarMov";
import swal from "sweetalert2";
import { useLoading } from "../../../components/Loading/useLoading";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { ModalConfirmReport } from "./components/modales/modalConfirmReport";
import { json } from "react-router-dom";
import { AreaAlmacenEnum } from "../../../@enums/tipo_almacen";
import { useSelector } from "react-redux";
import { TicketLocal } from "../../../hooks/sendPrint";
import { ModalConfirmacionTag } from "./components/modales/modalConfirmacionTag";
import { RevertirReporte, RevertirReporteContinuo } from "../../../hooks/reportMovimiento";
import { useSnackbar } from "notistack";

const TableProcesosPanel = ({
  sample,
  codes,
  almacen,
  movimientos,
  get_cargados,
  get_procesados,
  setIsReporting,
  setMovReporting,
  canReport,
  setAyudasVisuales,
  setOpenAyudas,
  needExtraInfo,
  checkCert,
}) => {
  const theme = useContext(ThemeContext);
  const inputCodigo = useRef(null);
  const inputCantidad = useRef(null);
  const inputRack = useRef(null);
  const inputEstacion = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const { procesarMovimientoMutation } = ProcesarMovimiento();
  const { revertirReporteoMutation } = RevertirReporteContinuo();
  const [cantidad, setCantidad] = useState(null);
  const [rack, setRack] = useState(null);
  const [estacion, setEstacion] = useState(null);
  const [errorCode, setErrorCode] = useState(false);
  const [errorCantidad, setErrorCantidad] = useState(false);
  const [errorRack, setErrorRack] = useState(false);
  const [errorEst, setErrorEst] = useState(false);
  const [product, setProduct] = useState(null);
  const [valueAuto, setValueAuto] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [reproceso, setReproceso] = useState(false);
  const [idMov, setIdMov] = useState(null);
  const { setAppLoading } = useLoading();
  const { ticketLocalMutation } = TicketLocal();
  const [tagsPrint, setTagsPrint] = useState(null);
  const [bodyReverse, setBodyReverse] = useState(null);
  const [openConfirmTag, setOpenConfirmTag] = useState(false);

  const printerId = useSelector((state) => state.app.printerId);

  const [openRows, setOpenRows] = useState({});
  const [movimientosData, setMovimientosData] = useState({});

  const rows = sample;

  const toggleRow = (index) => {
    setOpenRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const setMovimientosForRow = (index, data) => {
    setMovimientosData((prev) => ({
      ...prev,
      [index]: data,
    }));
  };

  const autocomplete_code = (e) => {
    if (e !== null) {
      setProduct(e);
      setValueAuto(e);
      setErrorCode(false);
      inputCantidad.current.focus();
    } else {
      setErrorCode(true);
      setProduct(null);
    }
  };

  const validate = (value) => {
    let mov = movimientos.find((item) => item?.part_id === product?.id);
    if (
      product === null ||
      value === "" ||
      (needExtraInfo && (rack === null || estacion === null)) ||
      parseInt(value) > mov?.existencia_total ||
      parseInt(value) < 1 ||
      isNaN(parseInt(value))
    ) {
      if (product === null) setErrorCode(true);
      if (
        value === "" ||
        parseInt(value) > mov?.existencia_total ||
        parseInt(value) < 1 ||
        isNaN(parseInt(value))
      )
        setErrorCantidad(true);

      if (rack === null || rack === "") setErrorRack(true);
      if (estacion === null || estacion === "") setErrorEst(true);
      return false;
    } else {
      setErrorCantidad(false);
      setErrorCode(false);
      setErrorRack(false);
      setErrorEst(false);
      return true;
    }
  };

  const procesar = (e) => {
    if (e.key === "Enter") {
      setAppLoading(true);
      if (validate(cantidad)) {
        let data = {
          cantidad: cantidad,
          almacen: almacen,
          parte: product?.id,
          rack: rack,
          estacion: estacion,
          reproceso,
          printerId,
        };
        procesarMovimientoMutation(data, {
          onSuccess: async (data) => {
            if (data?.success) {
              console.log("data", data);
              swal.fire({
                position: "top-end",
                icon: "success",
                title: data?.mensaje,
                showConfirmButton: false,
                timer: 1000,
              });
              if (data?.data?.continuo && data?.data?.format) {
                try {
                  setTagsPrint(data?.data?.prints);
                  setBodyReverse(data?.data?.revers_data);
                  for (let print of data?.data?.prints) {
                    await new Promise((resolve, reject) => {
                      ticketLocalMutation(print, {
                        onSuccess: (response) => {
                          console.log(response);
                          resolve(); // Solo avanza cuando se complete esta petición
                        },
                        onError: (error) => {
                          console.log(error);
                          reject(error); // Detiene la secuencia si hay error
                        },
                      });
                    });
                  }
                  setAppLoading(false);
                  setOpenConfirmTag(true);
                } catch (error) {
                  console.error("Error en el proceso de impresión:", error);
                }
              }
            } else {
              swal.fire({
                position: "top-end",
                icon: "error",
                title: data?.mensaje,
                showConfirmButton: false,
                timer: 1000,
              });
            }
            setValueAuto(null);
            setProduct(null);
            setCantidad(null);
            setEstacion(null);
            setRack(null);
            inputCodigo.current.focus();
            get_cargados(almacen);
            get_procesados(almacen);
          },
          onError: (error) => {
            swal.fire({
              position: "top-end",
              icon: "error",
              title: error?.mensaje,
              showConfirmButton: false,
              timer: 1000,
            });
            setValueAuto(null);
            get_cargados(almacen);
            get_procesados(almacen);
          },
          onSettled: () => {
            setReproceso(false);
            setAppLoading(false);
          },
        });
      } else {
        setAppLoading(false);
      }
    }
    get_cargados(almacen);
    get_procesados(almacen);
  };

  const revertData = (data) => {
    setAppLoading(true);
    revertirReporteoMutation(bodyReverse, {
      onSuccess: (data) => {
        enqueueSnackbar("Movimientos revertidos", {
          autoHideDuration: 2000,
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onError: (error) => {
        enqueueSnackbar("No se pudo revertir los movimientos", {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        setAppLoading(false);
        onCloseReport();
      },
    });
  };

  const onCloseReport = () => {
    inputCantidad.current.value = "";
    if (needExtraInfo) {
      inputRack.current.value = "";
      inputEstacion.current.value = "";
    }
    inputCodigo.current.focus();
    get_cargados(almacen);
    get_procesados(almacen);
    setAppLoading(false);
    setOpenConfirmTag(false);
    setTagsPrint(null);
    setBodyReverse(null);
  };

  const goReporting = (mov) => {
    const data = rows.filter((item) => item.part_id === mov && item.activo);
    const movimiento = data[0];
    const sumaExistenciaTotal = data.reduce(
      (acumuladorProcesos, procesoActual) => {
        const sumaProceso = procesoActual?.datos?.reduce(
          (acumuladorDatos, datoActual) =>
            acumuladorDatos + datoActual?.existencia_total,
          0,
        );
        return acumuladorProcesos + sumaProceso;
      },
      0,
    );
    movimiento.existencia_total = sumaExistenciaTotal;
    setMovReporting({ ...movimiento });
    setIsReporting(true);
  };

  function Row(props) {
    const { row, index } = props;

    // ⭐ Obtener el estado desde el componente padre
    const open = openRows[index] || false;
    const movimientos = movimientosData[index] || [];

    const open_subtabla = (rowIndex) => {
      if (open) {
        toggleRow(rowIndex);
        setMovimientosForRow(rowIndex, []);
      } else {
        get_movimientos(rowIndex);
        toggleRow(rowIndex);
      }
    };

    const get_movimientos = (rowIndex) => {
      setMovimientosForRow(rowIndex, row?.datos);
    };

    const confirmacion_reporte = (mov) => {
      setTimeout(() => {
        setOpenConfirm(true);
        setIdMov(mov);
      }, 500);
    };

    const getResources = (id) => {
      setAyudasVisuales(id);
      setOpenAyudas(true);
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell sx={{ p: 0.5 }}>
            <IconButton
              aria-label="expand row"
              size="small"
              style={{ width: 25 }}
              onClick={() => open_subtabla(index)}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell
            align="center"
            onClick={() => getResources(row["part_id"])}
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5,
            }}
          >
            {row.codigo}
          </TableCell>
          <TableCell
            align="center"
            onClick={() => getResources(row["part_id"])}
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5,
            }}
          >
            {row.nombre}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 0.5,
            }}
          >
            {row?.acciones && canReport && row?.activo && (
              <Button
                variant="contained"
                className="btn_system"
                sx={{ fontSize: 12, height: 35 }}
                disableElevation
                onClick={() =>
                  checkCert(() => confirmacion_reporte(row?.part_id))
                }
              >
                Reportar
              </Button>
            )}
            {canReport && !row?.activo && (
              <Chip
                label="Reportado"
                variant="outlined"
                sx={{ borderRadius: 2 }}
              />
            )}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Desgloce de movimientos
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Serial
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Etiqueta
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Cantidad
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Rack/Barril
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Estación Rec.
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {movimientos.map((mov) => (
                      <TableRow key={mov?.moin_id}>
                        <TableCell align="center">{mov?.serial}</TableCell>
                        <TableCell align="center">{mov?.tag}</TableCell>
                        <TableCell align="center">
                          {mov?.existencia_total}
                        </TableCell>
                        <TableCell align="center">{mov?.rack}</TableCell>
                        <TableCell align="center">{mov?.estacion}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Grid container spacing={0} sx={{ display: "flex", alignItems: "start" }}>
      <Grid item xs={6} sx={{ p: 0, pr: 1, mb: errorCantidad ? 3 : 0 }}>
        {codes !== null && (
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={codes}
            onChange={(e, newValue) => autocomplete_code(newValue)}
            value={valueAuto}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Código"
                inputRef={inputCodigo}
                onClick={() => {
                  checkCert(() => {});
                }}
                error={errorCode}
                helperText={errorCode ? "Ingrese un código válido" : ""}
                size="small"
              />
            )}
          />
        )}
      </Grid>
      <Grid item xs={6} sx={{ p: 0, pl: 1, mb: errorCantidad ? 3 : 0 }}>
        <TextField
          id="cantidad_reporte"
          label="Ingrese una cantidad válida"
          fullWidth
          size="small"
          inputRef={inputCantidad}
          onClick={() => {
            checkCert(() => {});
          }}
          onKeyDown={(e) => procesar(e)}
          onChange={(e) =>
            setCantidad(e.target.value !== "" ? parseInt(e.target.value) : null)
          }
          error={errorCantidad}
          helperText={errorCantidad ? "Ingrese una cantidad válida" : ""}
          sx={{ color: theme.palette.primary.input, height: "10px !important" }}
        />
      </Grid>
      {needExtraInfo && (
        <>
          <Grid item xs={6} sx={{ p: 0, pr: 1, mt: 1 }}>
            <TextField
              id="rack"
              label="Rack/Barril"
              fullWidth
              size="small"
              inputRef={inputRack}
              onClick={() => {
                checkCert(() => {});
              }}
              onKeyDown={(e) => procesar(e)}
              onChange={(e) =>
                setRack(e.target.value !== "" ? e.target.value : null)
              }
              error={errorRack}
              helperText={errorRack ? "Ingrese una rack/barril válido" : ""}
              sx={{
                color: theme.palette.primary.input,
                height: "10px !important",
              }}
            />
          </Grid>
          <Grid item xs={6} sx={{ p: 0, pl: 1, mt: 1 }}>
            <TextField
              id="estacion"
              label="Estación recubrimiento"
              fullWidth
              size="small"
              inputRef={inputEstacion}
              onClick={() => {
                checkCert(() => {});
              }}
              onKeyDown={(e) => procesar(e)}
              onChange={(e) =>
                setEstacion(e.target.value !== "" ? e.target.value : null)
              }
              error={errorEst}
              helperText={errorEst ? "Ingrese una estación válida" : ""}
              sx={{
                color: theme.palette.primary.input,
                height: "10px !important",
              }}
            />
          </Grid>
        </>
      )}
      <Grid item xs={12} sx={{ p: 0, mt: 4.5 }}>
        <Paper
          style={{ maxHeight: "100vh", overflowY: "scroll", width: "100%" }}
          sx={{ boxShadow: "none" }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h8"
              sx={{ fontWeight: 500, mb: 0 }}
              gutterBottom
              component="div"
            >
              Procesados
            </Typography>

            {needExtraInfo && (
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={reproceso}
                      onChange={(e) => setReproceso(e.target.checked)}
                    />
                  }
                  label="Reproceso"
                />
              </FormGroup>
            )}
          </div>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
              <TableHead
                sx={{
                  display: "table-head",
                  backgroundColor: theme.palette.primary.main,
                  fontWeight: 600,
                }}
              >
                <TableRow>
                  <TableCell align="center" sx={{ color: "white" }} />
                  <TableCell align="center" sx={{ color: "white" }}>
                    Código
                  </TableCell>
                  <TableCell align="center" sx={{ color: "white" }}>
                    Nombre
                  </TableCell>
                  <TableCell align="center" sx={{ color: "white" }}>
                    Acciones
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map((row, index) => (
                  <Row key={index} row={row} index={index} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Grid>
      <ModalConfirmReport
        key="modal_conf"
        open={openConfirm}
        setOpen={setOpenConfirm}
        idMov={idMov}
        setIdMov={setIdMov}
        goReport={goReporting}
      />
      <ModalConfirmacionTag
        key="modal_conf"
        open={openConfirmTag}
        setOpen={setOpenConfirmTag}
        dataReprint={tagsPrint}
        onClose={onCloseReport}
        revertData={revertData}
      />
    </Grid>
  );
};

export default TableProcesosPanel;
